import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8r7b7k3ydp: FaireBrandEntity = {
  token: "b_8r7b7k3ydp",
  type: "brand",
  name: "Jon & Vinny's",
  avatarUrl:
    "https://cdn.faire.com/fastly/769a7840a29d9f3a99da2fab19920111b400e63aecb58b8f9cba0bb49cc9d65e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c89406fa17211b149722458f87d5883c6af8f022a265bf71de8fdf3172ae2773.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/769a7840a29d9f3a99da2fab19920111b400e63aecb58b8f9cba0bb49cc9d65e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c89406fa17211b149722458f87d5883c6af8f022a265bf71de8fdf3172ae2773.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 96,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Jon & Vinny’s Italian and Helen’s Wines are the namesake of chefs and restaurateurs Jon Shook, Vinny Dotolo, and partner Helen Johannesen. A beloved Los Angeles staple, Jon & Vinny’s is celebrated for its approachable, casual yet elevated take on Italian-American cuisine, serving breakfast, lunch, and dinner daily. With locations across Los Angeles, Miami, and now expanding internationally, we bring our signature flavors to guests far and wide.\n\nFor fans of our famous pancakes, we offer our Jon & Vinny's pancake mix, so you can recreate and share the taste of Jon & Vinny’s wherever you are!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.852Z",
    importedBy: "entity-db-cli",
  },
};
